import React from "react";
import {
  Create,
  SimpleForm,
  ReferenceInput,
  TextInput,
  BooleanInput
} from "admin-on-rest";
import SelectInput from "../../../components/CRM/SelectInput";
import DateInput from "../../../components/DateInput";
import DateTimeInput from "../../../components/DateTimeInput";
import TicketLayoutCreateForm from "./TicketLayouts/";
import AutoComplete from "material-ui/AutoComplete";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import {
  validateVirtualSlipDataCreate,
  validateBoost,
  validateBoostIdentificationNumber,
  validateStoreName
} from "./validations";
import {formStyle} from "./style";
import Checkbox from "material-ui/Checkbox";
import {bindActionCreators} from "redux";
import {reduxForm, change as changeFieldValue} from "redux-form";
import {connect} from "react-redux";

const betItems = [
  {id: "stryktipset", name: "Stryktipset"},
  {id: "europatipset", name: "Europatipset"},
  {id: "v75", name: "V75"},
  {id: "v86", name: "V86"}
];

class VirtualSlipCreateForm extends React.Component {
  state = {
    selectInputState: "stryktipset",
    boost: false
  };

  componentDidMount() {
    if (this.props.configuration && this.props.configuration.virtualslips) {
      const {history} = this.props;
      if (this.props.configuration.virtualslips.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.virtualslips.enabled !== true)
        history.replace(`/`);
    }
  }

  selectInputStateSet = value => {
    this.setState({selectInputState: value});
  };

  toggleBoost = () => {
    if (this.state.boost === false) {
      this.setState({boost: true});
    } else {
      this.setState({boost: false});
      this.props.changeFieldValue("record-form", "boost.price", "");
      this.props.changeFieldValue("record-form", "boost.digits", "");
    }
  };

  render() {
    const props = {...this.props};

    return (
      <Create title="resources.virtualSlips.titleCreate" {...props}>
        <SimpleForm redirect="edit" validate={validateVirtualSlipDataCreate}>
          <SelectInput
            selectInputStateSet={this.selectInputStateSet}
            label="resources.virtualSlips.inputs.betType"
            elStyle={formStyle.selectInput}
            source="type"
            choices={betItems}
            defaultValue={this.state.selectInputState}
            translateChoice={false}
            style={formStyle.containerInput}
          />

          <ReferenceInput
            label="resources.virtualSlips.inputs.storeName"
            source="kiosk_id"
            reference="kiosks"
            validate={validateStoreName}
            sort={{field: "name", order: "ASC"}}
            perPage={50}
            allowEmpty={false}
            filterToQuery={name => ({name_like: name})}
            style={formStyle.containerInput}
          >
            <AutocompleteInput
              options={{filter: AutoComplete.caseInsensitiveFilter}}
            />
          </ReferenceInput>

          <TextInput
            label="resources.virtualSlips.inputs.expert"
            source="expert"
            style={formStyle.containerInput}
          />

          <div style={formStyle.clearDiv} />
          <TextInput
            label="resources.virtualSlips.inputs.sharegameSize"
            source="shares"
            style={formStyle.containerInput}
          />

          {this.state.selectInputState === "v75" ||
          this.state.selectInputState === "v86" ? (
            <TextInput
              label="resources.virtualSlips.inputs.agentCharge"
              source="agent_charge"
              style={formStyle.containerInput}
            />
          ) : (
            <TextInput
              label="resources.virtualSlips.inputs.totalCost"
              source="total_cost"
              style={formStyle.containerInput}
            />
          )}

          <TextInput
            label="resources.virtualSlips.inputs.shareCost"
            source="share_cost"
          />
          <div style={formStyle.clearDiv} />
          <DateInput
            label="resources.virtualSlips.inputs.startDate"
            source="start_date"
            locale="sv"
            hideCalendarDate={true}
            showIcon={false}
            style={formStyle.containerInput}
            textFieldStyle={formStyle.dateInput.textFieldStyle}
            customInputStyle={formStyle.dateInput.customInputStyle}
          />

          {this.state.selectInputState === "v75" ||
          this.state.selectInputState === "v86" ? (
            <DateTimeInput
              label="resources.virtualSlips.inputs.betClosingTime"
              source="closing_time"
              locale="sv"
              hideCalendarDate={true}
              showIcon={false}
              textFieldStyle={formStyle.dateInput.textFieldStyle}
              customInputStyle={formStyle.dateInput.customInputStyle}
              wrapperStyle={formStyle.dateInput.wrapperStyle}
              timeStyle={formStyle.dateInput.timeStyle}
            />
          ) : (
            <DateInput
              label="resources.virtualSlips.inputs.betClosingTime"
              source="closing_time"
              locale="sv"
              hideCalendarDate={true}
              showIcon={false}
              textFieldStyle={formStyle.dateInput.textFieldStyle}
              customInputStyle={formStyle.dateInput.customInputStyle}
            />
          )}

          {this.state.selectInputState === "v75" && (
            <div>
              <Checkbox
                label="Boost"
                labelPosition="left"
                style={formStyle.checkboxStyle}
                onCheck={this.toggleBoost}
              />
            </div>
          )}
          {this.state.selectInputState === "v75" &&
            this.state.boost && (
              <TextInput
                label="Boost"
                source="boost.price"
                validate={validateBoost}
              />
            )}
          {this.state.selectInputState === "v75" &&
            this.state.boost && (
              <TextInput
                label="Boost Identification Number"
                source="boost.digits"
                validate={validateBoostIdentificationNumber}
              />
            )}

          <div style={formStyle.clearDiv} />

          <TicketLayoutCreateForm
            {...props}
            selectInputState={this.state.selectInputState}
          />

          <BooleanInput
            label="resources.gametips.inputs.published"
            source="published"
          />
        </SimpleForm>
      </Create>
    );
  }
}

const mapStateToProps = state => {
  return {
    configuration: state.configuration
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({changeFieldValue}, dispatch);
};

export default reduxForm({
  form: "record-form",
  fields: ["boost.price", "boost.digits"]
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VirtualSlipCreateForm)
);



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/VirtualSlipCreateForm.js